<template>
  <div class="child-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="child-page__container">
      <div class="child-page__welcome sides-padding">
        <div class="container">
          <div class="child-page__welcome-inner">
            <h1 class="title">Детский реестр</h1>
            <p class="child-page__welcome-text">
              Приветствие нового малыша в вашей семье — это захватывающее время, но оно также может быть
              немного ошеломляющим из-за множества доступных товаров для новорожденных. Будь то ваш первый
              ребенок или новейшее дополнение к вашей семье, лучшее место для начала подготовки к рождению
              вашего новорожденного — это убедиться, что вы внесли все необходимое для ребенка в свой реестр
              детского душа.
            </p>
          </div>
        </div>
      </div>
      <div class="child-page__registry">
        <div class="container">
          <div class="child-page__registry-container">
            <div class="child-page__registry-one">
              <ImgComponent class="image" src="static/images/registry-1.png" />
              <div class="child-page__registry-buttons">
                <div class="child-page__registry-button">
                  <span class="title">Найти реестр</span>
                  <span class="subtitle">Ищите реестр ребенка, чтобы преподнести идеальный подарок.</span>
                  <a href="#" class="btn btn--main btn--md">
                    <span>Найти реестр</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="child-page__registry-two">
              <ImgComponent class="image" src="static/images/registry-2.png" />
              <div class="child-page__registry-buttons">
                <div class="child-page__registry-button">
                  <span class="title">Создайте реестр</span>
                  <span class="subtitle">
                    Найдите все, что вам нужно, чтобы приветствовать вашего ребенка дома.
                  </span>
                  <a href="#" class="btn btn--main btn--md">
                    <span>Войти</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="child-page__benefits sides-padding">
        <div class="container">
          <h3 class="title">Преимущества реестра</h3>
          <ul class="child-page__benefits-list">
            <li v-for="(item, i) in benefits" :key="i" class="child-page__benefits-item">
              <span>
                <IconComponent name="tick" />
              </span>
              <span class="child-page__benefits-item__title"> {{ item.title }} </span>
              <span class="child-page__benefits-item__subtitle"> {{ item.subtitle }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="child-page__tools sides-padding">
        <div class="container">
          <h3 class="title">Инструменты реестра</h3>
          <ul class="child-page__tools-list">
            <li v-for="(item, i) in tools" :key="i" class="child-page__tools-item">
              <span>
                <IconComponent :name="item.icon" />
              </span>
              <span class="child-page__tools-item__title"> {{ item.title }} </span>
              <span class="child-page__tools-item__subtitle"> {{ item.subtitle }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="child-page__company sides-padding">
        <div class="container">
          <div class="child-page__company-inner">
            <div class="child-page__company-inner__logo">
              <IconComponent name="elodie" />
            </div>
            <p class="child-page__company-text">
              Компания Elodie Details была создана в 2006 году в Швеции. Бренд поставил для себя задачу -
              создание необычных дизайнерских аксессуаров для малышей.
            </p>
            <a class="link">Перейти в каталог</a>
          </div>
        </div>
      </div>
      <ChildReviewsComponent :reviews="reviews" />
      <SliderComponent
        class="home-page__banners-slider"
        :items="banners"
        :hideArrows="true"
        v-slot="{ item }"
        :slider-options="cardsSliderOptions"
      >
        <BannerComponent :data="item" />
      </SliderComponent>
      <RecommendationsComponent :shares="shares" />
      <!--      <div class="child-page__faq sides-padding">-->
      <!--        <div class="container">-->
      <!--          <ImgComponent class="child-page__faq-image" src="static/images/faq.png" />-->
      <!--          <div class="child-page__faq-info sides-padding">-->
      <!--            <h2 class="title">Остались вопросы?</h2>-->
      <!--            <span class="subtitle">Давайте поговорим и ответим на все возникающие вопросы</span>-->
      <!--            <router-link-->
      <!--              :to="{ name: 'child', hash: '#callback' }"-->
      <!--              class="btn btn&#45;&#45;main btn&#45;&#45;md btn&#45;&#45;with-icon"-->
      <!--            >-->
      <!--              <span>Обсудить вопрос</span>-->
      <!--              <IconComponent name="arrow-right-1" />-->
      <!--            </router-link>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="child-page__registry sides-padding">
        <div class="container">
          <h3 class="title">Детский реестр</h3>
          <div class="child-page__registry-text">
            <p>
              Приветствие нового малыша в вашей семье — это захватывающее время, но оно также может быть
              немного ошеломляющим из-за множества доступных товаров для новорожденных. Будь то ваш первый
              ребенок или новейшее дополнение к вашей семье, лучшее место для начала подготовки к рождению
              вашего новорожденного — это убедиться, что вы внесли все необходимое для ребенка в свой реестр
              детского душа.
            </p>
            <p>
              Создав детский реестр buybuy BABY, вы не только сможете составить список желаний детских товаров
              в одном месте, но и послужит отличным руководством для ваших близких при поиске идеального
              подарка на рождение ребенка. Не говоря уже о том, что buybuy BABY гарантирует, что процесс
              регистрации товаров для детей очень прост.
            </p>
            <p>
              Создание окончательного списка желаний ребенка на расстоянии одного клика! Просто перейдите к
              «Начать свой реестр» и начните курировать свой список детей в Интернете. Если вы предпочитаете
              более практичный подход, запишитесь на прием к специалисту по обслуживанию клиентов в вашем
              местном магазине buybuy BABY, чтобы получить опыт один на один, когда они проведут вас через
              весь процесс и ответят на любые вопросы. Не рядом с магазином? Нет проблем, наши специалисты по
              обслуживанию клиентов в магазине также предлагают виртуальные консультации, чтобы вы могли
              начать работу, или вы можете загрузить наше мобильное приложение, чтобы управлять своим списком
              пожеланий в любое время.
            </p>
            <p>
              Со всем, от колясок, автокресел, кроваток, детского постельного белья и многого другого на
              выбор, может быть сложно точно знать, с чего начать при составлении списка для ребенка. К
              счастью, полезные инструменты buybuy BABY, такие как наш интерактивный контрольный список для
              детей, наша тщательно отобранная коллекция избранных реестров и наши подробные руководства по
              реестрам, гарантируют, что у вас есть все необходимое.
            </p>
            <p>
              Список младенцев от buybuy BABY не только гарантирует, что у вас есть все необходимое для
              новорожденного дома, но и предоставляет множество преимуществ реестра, которыми вы также можете
              наслаждаться. От бесплатной доставки в течение первого года жизни вашего ребенка (применяются
              исключения) до бесплатных подарочных наборов и 15% скидки на оставшиеся товары (после детского
              праздника) — экономия бесконечна.
            </p>
            <p>
              Кроме того, вы не единственный, кто может воспользоваться преимуществами реестра младенцев
              buybuy BABY; ваши близкие тоже. Поисковик детского реестра прост в использовании и его легко
              найти на веб-сайте, поэтому гости вашего детского праздника всегда будут иметь легкий доступ к
              вашему списку пожеланий. Кроме того, наш анализатор детского реестра гарантирует наличие
              подарков по разным ценам, а групповые подарки дают вашим близким возможность сделать идеальный
              подарок вместе.
            </p>
            <p>
              Независимо от того, являетесь ли вы будущим родителем или взволнованным любимым человеком,
              товары для малышей buybuy, полезные онлайн-инструменты и персонализированные льготы делают
              создание реестра ребенка простым первым шагом к подготовке и празднованию нового маленького
              комочка радости.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import IconComponent from "components/IconComponent.vue";
import DEFAULT_PAGE from "@/graphql/pages/DefaultPage.graphql";
import ChildReviewsComponent from "./components/ChildReviewsComponent.vue";
import SliderComponent from "components/SliderComponent.vue";
import BannerComponent from "./components/BannerComponent.vue";
import RecommendationsComponent from "./components/RecommendationsComponent.vue";

export default {
  name: "ChildPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: DEFAULT_PAGE,
      })
      .then(({ data }) => {
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  components: {
    ChildReviewsComponent,
    IconComponent,
    BreadcrumbsComponent,
    SliderComponent,
    BannerComponent,
    RecommendationsComponent,
  },
  data() {
    return {
      cardsSliderOptions: {
        slidesPerView: 1,
        pagination: false,
        clickable: false,
        preloadImages: true,
        loop: true,
      },
      shares: [
        {
          src: "/static/images/rec.png",
          published_at: "2022-09-27 18:49:02",
          title: "Эта коляска вам понравится",
        },
        {
          src: "/static/images/rec.png",
          published_at: "2022-09-27 18:49:02",
          title: "Эта коляска вам понравится",
        },
        {
          src: "/static/images/rec.png",
          published_at: "2022-09-27 18:49:02",
          title: "Эта коляска вам понравится",
        },
      ],
      reviews: [
        {
          name: "Abdula",
          description: "fydyjdkdvujsydfiuhk",
          created_at: "2022-09-27 18:49:02",
        },
        {
          name: "Magdi",
          description: "fydyjdkdvujsydfiuhk",
          created_at: "2022-09-27 18:49:02",
        },
        {
          name: "Amir",
          description: "fydyjdkdvujsydfiuhk",
          created_at: "2022-09-27 18:49:02",
        },
      ],
      banners: [
        {
          link: "https://google.com",
          subtitle: "Получи лучшие предложения",
          title: "Присоединяйся в наш клуб",
          img: {
            id: 119,
            alt: null,
            path: "/files/cropped/FLmLYmt3VqLpYnfsvHVyFVjL0TM81h4AQuGqZ1pd.jpg",
          },
        },
      ],
      benefits: [
        {
          title: "Работаем по всей России",
          subtitle:
            "Зарегистрируйтесь у нас и получите пакет с бесплатными образцами, купонами и копией нашего Руководства по регистрации детей.  Доступен для самовывоза только в магазинах.",
        },
        {
          title: "Широкий ассортимент",
          subtitle:
            "Зарегистрируйтесь у нас и получите пакет с бесплатными образцами, купонами и копией нашего Руководства по регистрации детей.  Доступен для самовывоза только в магазинах.",
        },
        {
          title: "Бесплатная школа мам",
          subtitle:
            "Зарегистрируйтесь у нас и получите пакет с бесплатными образцами, купонами и копией нашего Руководства по регистрации детей.  Доступен для самовывоза только в магазинах.",
        },
        {
          title: "Персональная помощь",
          subtitle:
            "Зарегистрируйтесь у нас и получите пакет с бесплатными образцами, купонами и копией нашего Руководства по регистрации детей.  Доступен для самовывоза только в магазинах.",
        },
      ],
      tools: [
        {
          icon: "task",
          title: "Работаем по всей России",
          subtitle:
            "Зарегистрируйтесь у нас и получите пакет с бесплатными образцами, купонами и копией нашего Руководства по регистрации детей.  Доступен для самовывоза только в магазинах.",
        },
        {
          icon: "diagram",
          title: "Широкий ассортимент",
          subtitle:
            "Зарегистрируйтесь у нас и получите пакет с бесплатными образцами, купонами и копией нашего Руководства по регистрации детей.  Доступен для самовывоза только в магазинах.",
        },
        {
          icon: "medal-star",
          title: "Бесплатная школа мам",
          subtitle:
            "Зарегистрируйтесь у нас и получите пакет с бесплатными образцами, купонами и копией нашего Руководства по регистрации детей.  Доступен для самовывоза только в магазинах.",
        },
        {
          icon: "message-search",
          title: "Персональная помощь",
          subtitle:
            "Зарегистрируйтесь у нас и получите пакет с бесплатными образцами, купонами и копией нашего Руководства по регистрации детей.  Доступен для самовывоза только в магазинах.",
        },
      ],
    };
  },
  mounted() {
    if (this.$route.hash) {
      document.querySelector(this.$route.hash).scrollIntoView({ block: "start", behavior: "smooth" });
    }
  },
  computed: {
    links() {
      return [{ title: "Детский реестр" }];
    },
  },
  metaInfo: {
    title: "Детский реестр",
  },
};
</script>

<style lang="stylus">
.child-page {
  width 100%
  display grid
  grid-gap 30px

  &__container {
    display grid
    align-items start
    gap 50px
    position relative
  }

  &__welcome {
    padding-top 126px
    padding-bottom 126px
    background url("/static/images/child.png")
    background-repeat no-repeat
    background-position right
    background-color var(--white)
    color: var(--main-color)
    +below(860px) {
      padding-top 80px
      padding-bottom 80px
    }
    +below(640px) {
      padding-top 50px
    }
    +below(440px) {
      padding 30px
    }

    &-inner {
      text-align left
      max-width 628px
    }

    .title {
      text-align left
      font-size 2.125em;
      text-transform none
      +below(840px) {
        font-size 1.75em
        line-height 150%
      }
      +below(440px) {
        font-size 1.5em
      }
    }

    &-text {
      font-size: 1.125em
      line-height: 160%;
      +below(440px) {
        font-size 1em
      }
    }
  }

  &__registry {
    &-container {
      display flex
      gap 32px
      margin-top -100px
      padding 0 10px

      +below(1065px) {
      flex-direction column
      align-items center
      }

      .image {
        width 100%
        max-width 634px
        height 100%
        max-height 312px
        border-radius 15px
      }
    }

    &-buttons {
      padding 0 59px
      margin-top -50px

      +below(475px) {
        padding 0px 30px
      }
    }

    &-button {
      background #EFF0F1
      border-radius 15px
      display flex
      flex-direction column
      align-items center
      gap 15px
      padding 30px 30px
      max-height 223px
      max-width 516px

      +below(475px) {
      padding 20px 20px
      }
      //+below(385px) {
      //  padding 10px 10px
      //}

      .title {
        font-family var(--font_regular)
        font-weight: 700;
        font-size: 1.5em
        line-height: 150%;
        text-transform: uppercase;
        text-align center
        margin-bottom 20px
        +below(840px) {
          font-size 1.25em
        }
        +below(440px) {
          font-size 1.125em
        }
      }

      .subtitle {
        text-align center
      }
    }
  }

  &__info {
    .title {
      margin-bottom: 30px;
    }

    &-text {
      column-count 2
      column-gap 30px
      +below(640px) {
        column-count 1
      }
    }
  }

  &__benefits {
    .title {
      margin-bottom: 30px;
    }

    &-list {
      display grid
      grid-template-columns repeat(4, 1fr)
      grid-gap 30px
      +below(1100px) {
        grid-template-columns repeat(3, 1fr)
      }
      +below(860px) {
        grid-template-columns repeat(2, 1fr)
      }
      +below(640px) {
        gap 20px
      }
      +below(540px) {
        grid-template-columns 1fr
      }
      +below(440px) {
        grid-gap 10px
      }
    }

    &-item {
      height: auto;
      border: 1px solid var(--main-color-75)
      border-radius: var(--small_radius)
      padding 20px
      display flex
      flex-direction column
      align-items center
      gap 18px
      +below(640px) {
        padding 15px
        font-size 1em
        gap 12px
      }

      &__title {
        font-weight: 700;
        font-size: 1.125em
        line-height: 140%;
      }

      &__subtitle {
        font-weight: 400;
        font-size: 0.875em
        line-height: 145%;
        text-align center
      }

      span:first-child {
        position relative
        display flex
        border-radius 50%
        flex-shrink 0
        padding 5px
        background var(--main-color-25)

        .icon {
          width 20px
          height 20px
          background var(--main-color)
          border-radius 50%

          svg {
            flex-shrink 0
            width 24px
            height 24px

            path {
              stroke var(--white)
            }
          }
        }
      }
    }
  }

  &__tools {
    .title {
      margin-bottom: 30px;
    }

    &-list {
      display grid
      grid-template-columns repeat(4, 1fr)
      grid-gap 30px
      +below(1100px) {
        grid-template-columns repeat(3, 1fr)
      }
      +below(860px) {
        grid-template-columns repeat(2, 1fr)
      }
      +below(640px) {
        gap 20px
      }
      +below(540px) {
        grid-template-columns 1fr
      }
      +below(440px) {
        grid-gap 10px
      }
    }

    &-item {
      height: auto;
      border: 1px solid var(--main-color-75)
      border-radius: var(--small_radius)
      padding 20px
      display flex
      flex-direction column
      align-items center
      gap 18px
      +below(640px) {
        padding 15px
        font-size 1em
        gap 12px
      }

      &__title {
        font-weight: 700;
        font-size: 1.125em
        line-height: 140%;
      }

      &__subtitle {
        font-weight: 400;
        font-size: 0.875em
        line-height: 145%;
        text-align center
      }

      span:first-child {
        position relative
        display flex
        border-radius 50%
        flex-shrink 0
        padding 10px
        background var(--gray)

        .icon {
          width 20px
          height 20px
          border-radius 50%

          svg {
            flex-shrink 0
            width 24px
            height 24px

            path {
              stroke var(--main-color)
            }
          }
        }
      }
    }
  }

  &__company {
    padding 126px
    background url("/static/images/company.png")
    background-repeat no-repeat
    background-size cover
    background-position center
    color: var(--main-color)
    +below(860px) {
      padding-top 80px
      padding-bottom 80px
    }
    +below(640px) {
      padding-top 50px
      padding-bottom 50px
    }
    +below(440px) {
      padding 30px
    }

    .container {
      display flex
      justify-content center
    }

    &-inner {
      text-align center
      max-width 363px
      background rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(2px);
      border-radius: 20px;
      padding 30px

      &__logo {
        margin-bottom 20px
        +below(840px) {
          font-size 1.75em
          line-height 150%
        }
        +below(440px) {
          font-size 1.5em
        }
      }

      .link {
        text-decoration underline
      }
    }

    &-text {
      font-size 0.875em
      line-height 160%
      margin-bottom 20px
      +below(440px) {
        font-size 1em
      }
    }
  }

  &__registry {
    .title {
      margin-bottom: 30px;
    }

    &-text {
      column-count 2
      column-gap 30px
      +below(640px) {
        column-count 1
      }
    }
  }

  &__faq {
    .container {
      background #EFF0F1
      border-radius 15px
      display flex
      flex-direction column
      position relative
      align-items center
      padding 105px 0 105px 0

      +below(500px) {
      padding 55px 0 55px 0
      }
    }

    &-image {
      max-width 532px
      max-height 277px
      position absolute
      bottom 66%
    }

    &-info {
      display flex
      flex-direction column
      align-items center
      gap 15px
      margin-top 35px

      h2 {
        margin-bottom 0
      }

      span {
        text-align center
      }

    }
  }
}
</style>
